<template>
    <div class="yk-btt" :class="{ 'btt-show': show }" @click="goBackTop">
        <img class="btt-img" src="../../static/assets/image/yk-back-top.png" />
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false,
            isTop: true,
            timer: undefined
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll() {
            const scrollTop = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 100) {
                this.show = true;
            } else {
                this.show = false;
            }
            if (!this.isTop) {
                clearInterval(this.timer);
            }
            this.isTop = false;
        },
        goBackTop() {
            this.timer = setInterval(() => {
                const osTop = document.documentElement.scrollTop || document.body.scrollTop;
                const ispeed = Math.floor(-osTop / 4);
                // eslint-disable-next-line no-multi-assign
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                this.isTop = true;
                if (osTop === 0) {
                    clearInterval(this.timer);
                }
            }, 30);
        }
    }
};
</script>
<style lang="scss" scoped>
.yk-btt {
    display: none;
    position: fixed;
    // top: 53vh;
    bottom: 136px;
    right: 35px;
    width: 100px;
    height: 100px;
    z-index: 2;
    .btt-img {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
    }
}
.btt-show {
    display: block;
    animation: btt 0.1s 1;
}

@keyframes btt {
    0% { opacity: 0; }
    100% { opacity: 1; }
}
</style>



// WEBPACK FOOTER //
// src/components/h-back-to-top.vue